'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.composeToggleWidgetEvent = composeToggleWidgetEvent;
exports.composeCoverClickEvent = composeCoverClickEvent;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var EVENTS = _constantsAnalytics2.default.EVENTS,
    CATEGORIES = _constantsAnalytics2.default.CATEGORIES,
    ACTIONS = _constantsAnalytics2.default.ACTIONS,
    LABELS = _constantsAnalytics2.default.LABELS,
    CUSTOM_DIMENSIONS = _constantsAnalytics2.default.CUSTOM_DIMENSIONS;


function composeWhileYouWaitEvent(_ref) {
  var event = _ref.event,
      gtmAction = _ref.gtmAction,
      gtmLabel = _ref.gtmLabel,
      _ref$gtmValue = _ref.gtmValue,
      gtmValue = _ref$gtmValue === undefined ? 1 : _ref$gtmValue,
      payload = _objectWithoutProperties(_ref, ['event', 'gtmAction', 'gtmLabel', 'gtmValue']);

  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(event, _extends({
    gtmCategory: CATEGORIES.WHILE_YOU_WAIT,
    gtmAction: gtmAction,
    gtmLabel: gtmLabel,
    gtmValue: gtmValue,
    gtmContentType: CUSTOM_DIMENSIONS.CONTENT_TYPES.BIB
  }, payload))]);
}

function composeToggleWidgetEvent(_ref2) {
  var open = _ref2.open;

  return composeWhileYouWaitEvent({
    event: EVENTS.WHILE_YOU_WAIT_TOGGLE_WIDGET,
    gtmAction: ACTIONS.TOGGLE_OPTION,
    gtmLabel: open ? LABELS.OPEN : LABELS.CLOSE
  });
}

function composeCoverClickEvent() {
  return composeWhileYouWaitEvent({
    event: EVENTS.WHILE_YOU_WAIT_COVER_CLICK,
    gtmAction: ACTIONS.CLICK_IMAGE,
    gtmLabel: LABELS.BIB_COVER
  });
}

exports.default = {
  composeToggleWidgetEvent: composeToggleWidgetEvent,
  composeCoverClickEvent: composeCoverClickEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/whileYouWaitEventComposer.js
// module id = 591
// module chunks = 0 2 4 5 6 8 9 10 11